<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
            <v-toolbar flat>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="title">
                      {{ memberName }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-toolbar>
            <v-list class="pt-0">
              <v-divider></v-divider>
              <v-list-tile v-for="(item) in sideMenu" :key="item.name" :to="{ name: item.name, params: item.params }">
                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'memberDet', text: 'Details' }
      ],
      newMember: false,
      memberName: null
    }
  },
  created() {
    if (this.id === 'new') {
      this.newMember = true
    } else {
      this.newMember = false
      this.sideMenu.push({
        name: 'subMemberList',
        text: 'Sub Member',
        params: {
          id: this.id
        }
      })
      this.sideMenu.push({
        name: 'fireTranList',
        text: 'Fire Transaction',
        params: {
          appID: 'FI',
          id: this.id
        }
      })
      this.sideMenu.push({
        name: 'maidTranList',
        text: 'Maid Transaction',
        params: {
          appID: 'MD',
          id: this.id
        }
      })
      this.sideMenu.push({
        name: 'travelTranList',
        text: 'Travel Transaction',
        params: {
          appID: 'TR',
          id: this.id
        }
      })
    }
    this.breadcrumb = this.derieveBreadcrumbByName('membersList')
    this.breadcrumb.push({
      name: 'memberDet',
      text: this.title
    })
  },
  methods: {
    async doInit() {
      if (!this.newMember) {
        const apiURI = this.menu.memberGet
        if (apiURI) {
          const expand = {
            id: this.id
          }
          this.$http.get(expandURI(apiURI, expand)).then(result => {
            this.memberName = result.data.name
          }).catch(err => {
            // this.memberName = null
          })
        }
      } else {
        this.memberName = 'New Member'
      }
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName'
    ]),
    menu() {
      return this.$store.state.adminMember.menu
    },
    title() {
      if (this.newMember) {
        return 'New Member'
      } else {
        return 'Member Detail'
      }
    }
  },
  props: ['id']
}
</script>

<style>
</style>
